/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Complete_Signin_TitleInputs */

const en_login_complete_signin_title = /** @type {(inputs: Login_Complete_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Sign-In`)
};

const fr_login_complete_signin_title = /** @type {(inputs: Login_Complete_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer la Connexion`)
};

const de_login_complete_signin_title = /** @type {(inputs: Login_Complete_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständige Anmeldung`)
};

const it_login_complete_signin_title = /** @type {(inputs: Login_Complete_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa l'accesso`)
};

const ru_login_complete_signin_title = /** @type {(inputs: Login_Complete_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершить вход в систему`)
};

const es_login_complete_signin_title = /** @type {(inputs: Login_Complete_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio de sesión completo`)
};

const zh_cn2_login_complete_signin_title = /** @type {(inputs: Login_Complete_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成登录`)
};

const ja_login_complete_signin_title = /** @type {(inputs: Login_Complete_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインを完了する`)
};

const hi_login_complete_signin_title = /** @type {(inputs: Login_Complete_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग इन पूरा करें`)
};

const pt_pt2_login_complete_signin_title = /** @type {(inputs: Login_Complete_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir o login`)
};

/**
* | output |
* | --- |
* | "Complete Sign-In" |
*
* @param {Login_Complete_Signin_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_complete_signin_title = /** @type {((inputs?: Login_Complete_Signin_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Complete_Signin_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_complete_signin_title(inputs)
	if (locale === "de") return de_login_complete_signin_title(inputs)
	if (locale === "it") return it_login_complete_signin_title(inputs)
	if (locale === "ru") return ru_login_complete_signin_title(inputs)
	if (locale === "es") return es_login_complete_signin_title(inputs)
	if (locale === "zh-CN") return zh_cn2_login_complete_signin_title(inputs)
	if (locale === "ja") return ja_login_complete_signin_title(inputs)
	if (locale === "hi") return hi_login_complete_signin_title(inputs)
	if (locale === "pt-PT") return pt_pt2_login_complete_signin_title(inputs)
	return en_login_complete_signin_title(inputs)
});